<script setup lang="ts">
import { DialogTitle, type DialogTitleProps } from "radix-vue";
import { cn } from "@/lib/utils";

const props = defineProps<DialogTitleProps & { class?: string }>();
</script>

<template>
    <DialogTitle
        v-bind="props"
        :class="
            cn(
                'text-lg font-medium text-iron-700 dark:text-stone-50 leading-none tracking-[-0.02em]',
                props.class,
            )
        "
    >
        <slot />
    </DialogTitle>
</template>
